import { cubicEaseOut, transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
const Container = styled.nav `
  --colorInactive: ${brand.black};
  --colorActive: ${brand.black};
  --clickPadding: 10px;
  --gap: 15px;
  --height: 10px;
  --width: 100%;

  display: flex;
  flex-direction: row;
  gap: var(--gap);
  place-content: center;
  place-items: center;
  user-select: none;

  @media ${from(Device.Tablet)} {
    --clickPadding: 10px;
    --gap: 15px;
  }
`;
const Item = styled.button `
  ${transition('color, transform')}
  position: relative;
  display: flex;
  background: none;
  border: 0;
  color: var(--colorInactive);
  margin: 0;
  padding: var(--clickPadding) 0;
  place-content: center;
  place-items: center;
  transition: color 0.3s ease-out;
  height: var(--height);
  width: var(--width);
  flex: 1 1 20%;
  max-width: 100px;

  @media ${from(Device.Tablet)} {
    flex: 0 1 20%;
    max-width: 75px;
  }
  

  &::before {
    ${transition('transform')}
    content: '';
    display: block;
    border: none;
    color: currentColor;
    background-color: currentColor;
    height: var(--height);
    width: var(--width);
    transform: scaleY(30%);
  }

  /* Enable focus styles for Safari */
  &:focus {
    outline: auto;
    outline-color: currentColor;
    outline-offset: 5px;
    outline-width: thin;

  }

  /* Enable hover styles for Safari */
  &:hover {
    color: var(--colorActive);
  }

  /* Disable focus styles if focus visible is supported */
  &:not(:focus-visible):focus {
    outline: none;

    &::before {
      outline: none;
    }
  }

  /* Reapply focus styles for focus-visible browsers */
  &:focus-visible {
    outline: auto;
    outline-color: currentColor;
    outline-offset: 5px;
    outline-width: thin;

  }

  /* Apply hover styles for focus-visible browsers */
  &[aria-current='false']:not(:focus-visible):hover {
    color: var(--colorActive);

    &::before {
      transform: scaleY(60%);
    }
  }

  /* Apply active styles */
  &[aria-current='true'] {

    &::before {
      transform: scaleY(100%);
    }
  }

`;
const PlayPaths = css `
  &::before {
    clip-path: polygon(0 0, 50% 25%, 50% 75%, 0% 100%);
    left: 0;
  }

  &::after {
    clip-path: polygon(50% 25%, 100% 50%, 100% 50%, 50% 75%);
    right: 0;
  }
`;
const PausePaths = css `
  &::before {
    clip-path: polygon(0 0, 30% 0, 30% 100%, 0% 100%);
    left: 0;
  }

  &::after {
    clip-path: polygon(70% 0, 100% 0, 100% 100%, 70% 100%);
    right: 0;
  }
`;
const PlayPauseButton = styled.button `
  transition: opacity 0.2s ${cubicEaseOut};
  will-change: opacity;
  position: relative;
  border: 0;
  background: none;
  width: 24px;
  height: 24px;
  margin: var(--clickPadding) 0;
  opacity: 1;

  &::before,
  &::after {
    display: block;
    content: '';
    width: 24px;
    height: 24px;
    background: var(--colorInactive);
    position: absolute;
    top: 0;
    transition: clip-path 0.3s ease;
    will-change: clip-path;
  }

  /* Enable styles for Safari */
  &.focus-ring {
    outline: auto;
    outline-color: currentColor;
    outline-offset: 5px;
    outline-width: thin;
  }

  &.focus-ring,
  &:hover {
    opacity: 0.7;
  }

  &[data-paused='false'] {
    ${PausePaths};
  }

  &[data-paused='true'] {
    ${PlayPaths};
  }
`;
const DotPaginationStyles = {
    Container,
    Item,
    PlayPauseButton,
};
export default DotPaginationStyles;
